import { t } from '@/i18n';
import { CSV_DATA_2024 } from './2024-csv-data';
import { CSV_DATA_2025 } from './2025-csv-data';

type BasicInformationType =
  | 'organizationInformation'
  | 'projectSummary'
  | 'policyMeasureLawsAndRegulations'
  | 'subsidyRate'
  | 'relatedProjects';
type BudgetAndExecutionType = 'summary' | 'detail';
type WayToEffectType = 'purposeResult' | 'purposeConnection';
type InspectionEvaluationType = 'evaluation';
type PayeeType =
  | 'paymentInformation'
  | 'paymentBlockConnection'
  | 'paymentAmountBreakdown'
  | 'contract';
type RemarkType = 'remark';

type PublicDownloadCsvFileNameType =
  | BasicInformationType
  | BudgetAndExecutionType
  | WayToEffectType
  | InspectionEvaluationType
  | PayeeType
  | RemarkType;

export type PublicDownloadCsvDataType = {
  basicInformation: {
    key: BasicInformationType;
    localFileName: string;
  }[];
  budgetAndExecution: {
    key: BudgetAndExecutionType;
    localFileName: string;
  }[];
  wayToEffect: {
    key: WayToEffectType;
    localFileName: string;
  }[];
  inspectionEvaluation: {
    key: InspectionEvaluationType;
    localFileName: string;
  }[];
  payee: {
    key: PayeeType;
    localFileName: string;
  }[];
  remark: {
    key: RemarkType;
    localFileName: string;
  }[];
};

export type DownloadCsvGroupType = keyof PublicDownloadCsvDataType;

export const PublicDownloadCsvLabelModifier = {
  basicInformation: t('ps-download-csv-page-group-title-basic-information'),
  budgetAndExecution: t(
    'ps-download-csv-page-group-title-budget-and-execution',
  ),
  wayToEffect: t('ps-download-csv-page-group-title-way-to-effect'),
  inspectionEvaluation: t(
    'ps-download-csv-page-group-title-inspection-evaluation',
  ),
  payee: t('ps-download-csv-page-group-title-payee'),
  remark: t('ps-download-csv-page-group-title-remark'),
} as const satisfies Record<DownloadCsvGroupType, string>;

export const PublicDownloadCsvFileNameModifier = {
  organizationInformation: t(
    'ps-csv-name-rs-basic-information-organization-information',
  ),
  policyMeasureLawsAndRegulations: t(
    'ps-csv-name-rs-basic-information-policy-measure-laws-and-regulations',
  ),
  projectSummary: t('ps-csv-name-rs-basic-information-project-summary'),
  relatedProjects: t('ps-csv-name-rs-basic-information-related-projects'),
  subsidyRate: t('ps-csv-name-rs-basic-information-subsidy-rate'),
  detail: t('ps-csv-name-rs-budget-and-execution-detail'),
  summary: t('ps-csv-name-rs-budget-and-execution-summary'),
  evaluation: t('ps-csv-name-rs-inspection-evaluation'),
  contract: t('ps-csv-name-rs-payee-contract'),
  paymentAmountBreakdown: t('ps-csv-name-rs-payee-payment-amount-breakdown'),
  paymentBlockConnection: t('ps-csv-name-rs-payee-payment-block-connection'),
  paymentInformation: t('ps-csv-name-rs-payee-payment-information'),
  remark: t('ps-csv-name-rs-remark'),
  purposeConnection: t('ps-csv-name-rs-wey-to-effect-purpose-connection'),
  purposeResult: t('ps-csv-name-rs-wey-to-effect-purpose-result'),
} as const satisfies Record<PublicDownloadCsvFileNameType, string>;

/**
 * 年度別 CSV データ一覧
 *
 * 新しい年度のデータを追加する場合:
 * 1. `YYYY-csv-data.ts` ファイルを作成
 * 2. 下記配列に追加
 */
export const CSV_DATA: {
  year: string;
  data: PublicDownloadCsvDataType;
  criteriaDate: string;
  budgetAndExecutionCaption: string;
}[] = [
  {
    year: '2024',
    criteriaDate: '2025年2月14日',
    data: CSV_DATA_2024,
    budgetAndExecutionCaption: t(
      'ps-download-csv-2024-page-caption-budget-and-execution',
    ),
  },
  {
    year: '2025',
    criteriaDate: '2026年1月19日',
    budgetAndExecutionCaption: t(
      'ps-download-csv-2025-page-caption-budget-and-execution',
    ),
    data: CSV_DATA_2025,
  },
];
